import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, palette, spacing, variant, themeMode, baseUnit } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const kindStyles = {
  base: variant({
    prop: "kind",
    variants: {
      solid: {
        backgroundColor: themeMode({
          light: palette("neutral.100"),
          dark: palette("neutral.800")
        }),
        border: "1px solid rgba(0, 0, 0, 0)"
      },
      outline: {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: themeMode({ light: palette("neutral.300"), dark: palette("neutral.600") })
      }
    }
  }),
  hover: variant({
    prop: "kind",
    variants: {
      solid: {
        backgroundColor: themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") }),
        border: "1px solid rgba(0, 0, 0, 0)"
      },
      outline: {
        borderColor: themeMode({
          light: palette("neutral.100"),
          dark: palette("neutral.800")
        })
      }
    }
  }),
  active: variant({
    prop: "kind",
    variants: {
      solid: {
        backgroundColor: themeMode({ light: palette("neutral.300"), dark: palette("neutral.600") }),
        border: "1px solid rgba(0, 0, 0, 0)"
      },
      outline: {
        borderColor: themeMode({
          light: palette("neutral.200"),
          dark: palette("neutral.700")
        })
      }
    }
  })
};
const sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      height: baseUnit(6),
      py: 0,
      px: "xxs",
      gap: "xxs"
    },
    md: {
      fontSize: "md",
      height: baseUnit(9),
      py: 0,
      px: "xs",
      gap: "xs"
    },
    lg: {
      fontSize: "lg",
      height: baseUnit(12),
      py: 0,
      px: "sm",
      gap: "xs"
    }
  }
});
const shapeStyles = variant({
  prop: "shape",
  variants: {
    default: {
      borderRadius: 0
    },
    rounded: {
      borderRadius: "round"
    }
  }
});
const checkedStyles = variant({
  prop: "isChecked",
  compoundProp: "kind",
  variants: {
    true: {
      solid: {
        backgroundColor: themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") }),
        borderColor: themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") })
      },
      outline: {
        borderColor: themeMode({ light: palette("neutral.100"), dark: palette("neutral.800") })
      }
    }
  }
});
const Chip = styled(Box).attrs(({ onClick, isDisabled, isChecked, isLoading }) => ({
  "aria-disabled": isDisabled || isLoading,
  disabled: isDisabled || isLoading,
  "aria-pressed": onClick ? isChecked : null,
  "aria-busy": isLoading,
  role: onClick ? "button" : null
}))`
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    user-select: none;

    color: ${color("text.base")};
    ${kindStyles.base};
    ${sizeStyles};
    ${shapeStyles};

    ${checkedStyles};

    ${({ isError }) => !!isError && css`
            border-color: ${palette("danger.500")};
        `};

    ${({ onClick }) => !!onClick && css`
            cursor: pointer;

            &:hover {
                ${kindStyles.hover};
            }

            &:active {
                ${kindStyles.active};
            }

            &[aria-disabled='true'] {
                pointer-events: none;
            }
        `};
    ${({ isDisabled }) => isDisabled && css`
            opacity: 0.4;
        `}
    ${({ isMultiline }) => isMultiline && css`
            margin: ${spacing("xxs")};
        `}
`;

export { Chip };
//# sourceMappingURL=styled.es.js.map
